
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { storeApi } from "@/services/ApiService";
import { Applink, Category } from "@/api/api";
import itemPickerV2 from "@/components/controls/itemPickerV2.vue";

@Component({ components: {itemPickerV2} })
export default class ApplinkContent extends Vue {
  @Prop()
  category!: Category;
  appLinks: Array<Applink> = new Array<Applink>();
  pickedAppLink?: number = 0;

  async mounted() {
    this.appLinks.push(...(await (await storeApi.getAppLinks()).data));
    var res = await storeApi.getCategoryAppLink(this.category!.id);
    this.pickedAppLink = res.data.id;
  }

  save() {
    return storeApi.postCategoryAppLink(this.category!.id, this.pickedAppLink!);
  }
  handleChange(value: number) {
    this.pickedAppLink = value;
  }
}
